import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-web-tag-edit',
  templateUrl: './web-tag-edit.component.html',
  styleUrls: ['./web-tag-edit.component.css']
})
export class WebTagEditComponent extends BaseComponent implements OnInit {

  updateTagForm: FormGroup;
  controlEnabled: boolean = true;
  status: boolean = true;
  submitted = false;
  getCompanyobj: any = [];
  screenshot;
  tag_id;
  tagObj;
  screenshot_type;
  customer_id;
  selectedCompany;

  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private masterService:MasterService
  ) { super(); }

  ngOnInit() {
    this.controlEnabled = true;
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();
    let self = this;

    //get item details using id
    if (localStorage.getItem("edit_webinar_tag_id")) {
      this.tag_id = localStorage.getItem("edit_webinar_tag_id");
      this.selectedCompany = localStorage.getItem("_webinar_tag_edit_company_id");

      this.masterService.getWebinarTagById(this.selectedCompany,this.tag_id).subscribe(response => {
       
        if (response.status) {
          this.status = false;
          self.tagObj = response.data;
          self.dataBinding();
        }
      });
    }

    this.updateTagForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(50), this.noWhitespaceValidator]],
      description: ['', Validators.maxLength(100)],
      selectedCompany: [(this.customer_id == 0) ? '' : this.customer_id, Validators.required]
    });
  }

  get f() { return this.updateTagForm.controls; }

  dataBinding() {
    this.updateTagForm = this.formBuilder.group({
      name: [this.tagObj.name, [Validators.required, Validators.maxLength(50), this.noWhitespaceValidator]],
      description: [this.tagObj.description, Validators.maxLength(100)],
      selectedCompany: [this.selectedCompany, Validators.required]
    });
  }

  updateCategory() {
    this.submitted = true;
    if (this.updateTagForm.invalid) {
      return;
    }
    let { name, description, selectedCompany } = this.updateTagForm.value;
    let tagObj = {
      id: Number.parseInt(this.tag_id, 10),
      name: name,
      description: description,
      isactive:this.tagObj.is_active,
      company: selectedCompany
    }
    this.ngxSpinnerService.show();
    this.masterService.updateWebinarTag(tagObj).subscribe(data => {
      if (data.status) {
        this.toastrService.success("Tag Updated successfully");
        this.router.navigateByUrl(`/corporate/webinar-tag`);
      } else {
        this.toastrService.error(data.message);
      }
      this.ngxSpinnerService.hide();
    }, error => {
      console.error(error);
    });
  }

  isUrlValid(userInput) {
    return /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i.test(userInput);
  }

  getCompany() {
    let self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self);

    }, error => {
      console.log(error);
    });
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

}
